import React from 'react';
import {
  seedCalculationFingerprints,
  syncCalculatedAnswers,
} from './uniFormCalculations.js';

/**
 * Keep calculation answers in sync with their sources.
 *
 * ``recomputeOnMount`` is true on the public fill page (show the live
 * total immediately) and false on the admin editor (keep a stored
 * override until a source actually changes).
 *
 * Lives in its own module so ``uniFormCalculations.js`` stays a
 * React-free engine that Node can self-check without ``node_modules``.
 */
export function useLiveCalculations(questions, answers, setAnswers, { recomputeOnMount = true } = {}) {
  const printsRef = React.useRef(null);
  const formKey = (questions || []).map((q) => q.id).join(',');
  const lastFormKey = React.useRef('');

  React.useEffect(() => {
    if (!questions || !questions.length) return undefined;
    if (formKey !== lastFormKey.current) {
      printsRef.current = null;
      lastFormKey.current = formKey;
    }
    setAnswers((prev) => {
      if (printsRef.current == null) {
        if (!recomputeOnMount) {
          printsRef.current = seedCalculationFingerprints(questions, prev);
          return prev;
        }
        const result = syncCalculatedAnswers(
          questions, prev, {}, { force: true },
        );
        printsRef.current = result.fingerprints;
        return result.answers;
      }
      const result = syncCalculatedAnswers(questions, prev, printsRef.current);
      printsRef.current = result.fingerprints;
      return result.answers;
    });
    return undefined;
  }, [answers, formKey, questions, recomputeOnMount, setAnswers]);
}
